@if (row()) {
  <div class="content" (dragend)="managePointerEvents('auto')">
    <div
      class="first-column"
      [style.height.px]="agendaDetailedService.rowHeight + 1"
      [style.background-color]="backgroundDayColor()"
    >
      @if (row().isCurrent) {
        <div class="corner top-left"></div>
      }
      <div class="date" [class.current]="row().isCurrent">
        <div class="day-number">
          {{ row().dayNumber }}
        </div>
        <div class="date-details">
          <div class="day-name">
            {{ row().dayLabel }}
          </div>
          <div class="month-year">
            {{ row().monthYear }}
          </div>
        </div>
      </div>
      <div class="time-line">
        @for (time of timeLine(); track time) {
          <div class="time" [style.top]="time.top">{{time.time}}</div>
        }
      </div>
    </div>

    <div
      class="resources"
      #rowElement
      (mousemove)="onResizeTask($event, rowElement)"
    >
      @for (resource of row().resourcesCellsDay; track resource.resource.id) {
        <div
          class="resource"
          [style.width.px]="resourceWidth()"
          [class.last-resource]="resource.lastChild"
          (dragover)="$event.preventDefault()"
          (mouseleave)="onMouseLeave($event, resource.resource)"
        >
          @for (cell of resource.subCells; track cell.timeStart) {
            <div
              class="cell"
              [title]="cell.timeStart | timeFormat"
              [style.height.px]="cell.height"
              [style.--bg-color]="cell.backgroundColor"
              [class.border-dotted]="
                (row().options.hoursSection === 2 &&
                  cell.timeStart.minutes === 0) ||
                row().options.daySection === 2
              "
              (dragenter)="onDragEnterCell($event, cell)"
              (dragleave)="onDragLeaveCell(cell)"
              (drop)="onDropTask(cell)"
              (mousedown)="onSelectCell(cell)"
              (mouseover)="onOverCell($event, cell, resource.resource)"
              (mouseup)="onUnselectCell($event, resource.resource)"
            ></div>
          }
          @for (viewTask of resource.viewTasks; track viewTask.task.id) {
            <infl-agenda-detailed-task
              [draggable]="resource.options.canDrag && viewTask.task.enable"
              [viewTask]="viewTask"
              [options]="resource.options"
              (taskClick)="onTaskClick($event)"
              (startResizing)="startResizeTask($event)"
              (dragstart)="onDragStart(viewTask.task)"
              (mouseenter)="taskHover.emit(viewTask.task)"
              (mouseleave)="taskHover.emit(null)"
            ></infl-agenda-detailed-task>
          }
        </div>
      }
    </div>
  </div>
}
